import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useWishlist from "../hooks/useWishlist";
import useAuth from "../hooks/useAuth";
import useCart from "../hooks/useCart";
import "./WishlistPage.css";

const LOW_STOCK_THRESHOLD = 5;

const WishlistPage = () => {
  const { wishlist, removeFromWishlist, getWishlistCount } = useWishlist();
  const { addToCart } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login if not authenticated
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  const handleRemoveFromWishlist = (productId) => {
    removeFromWishlist(productId);
  };

  const handleAddToCart = (product) => {
    const stockQuantity = Number.isFinite(Number(product?.stockQuantity))
      ? Math.max(0, Math.floor(Number(product.stockQuantity)))
      : 0;

    if (stockQuantity <= 0) {
      return;
    }

    if (Array.isArray(product.availableSizes) && product.availableSizes.length > 0) {
      navigate(`/product/${product._id}`);
      return;
    }

    const success = addToCart(product, 1);
    if (success) {
      // Optionally remove from wishlist after adding to cart
      // removeFromWishlist(product._id);
    }
  };

  const handleContinueShopping = () => {
    navigate("/store");
  };

  if (!user) {
    return null; // Don't render anything while redirecting
  }

  return (
    <div className="wishlist-page-container">
      <h1>My Wishlist</h1>

      {wishlist.length === 0 ? (
        <div className="empty-wishlist">
          <h2>Your wishlist is empty</h2>
          <p>Add items to your wishlist to save them for later</p>
          <button className="continue-shopping" onClick={handleContinueShopping}>
            Continue Shopping
          </button>
        </div>
      ) : (
        <div className="wishlist-content">
          <div className="wishlist-items">
            {wishlist.map((item) => {
              const stockQuantity = Number.isFinite(Number(item?.stockQuantity))
                ? Math.max(0, Math.floor(Number(item.stockQuantity)))
                : 0;
              const isOutOfStock = stockQuantity === 0;
              const isLowStock = stockQuantity > 0 && stockQuantity <= LOW_STOCK_THRESHOLD;

              return (
                <div className="wishlist-item" key={item._id}>
                <div className="item-image">
                  <img src={item.images?.[0]} alt={item.title} />
                </div>
                <div className="item-details">
                  <h3 className="item-name">{item.title}</h3>
                  <div className="item-price">
                    <span className="current-price">₹{item.offerPrice}</span>
                    {item.price > item.offerPrice && (
                      <span className="original-price">₹{item.price}</span>
                    )}
                    {item.price > item.offerPrice && (
                      <span className="discount-percentage">
                        {Math.round(
                          ((item.price - item.offerPrice) / item.price) * 100
                        )}% OFF
                      </span>
                    )}
                  </div>
                  {isOutOfStock ? (
                    <p style={{ margin: "0 0 10px", color: "#b23d3d", fontWeight: 600 }}>Out of stock</p>
                  ) : isLowStock ? (
                    <p style={{ margin: "0 0 10px", color: "#9a5d00", fontWeight: 600 }}>
                      Only {stockQuantity} item(s) left in stock
                    </p>
                  ) : null}
                  <div className="item-actions">
                    <button
                      className="add-to-cart-btn"
                      onClick={() => handleAddToCart(item)}
                      disabled={isOutOfStock}
                    >
                      {isOutOfStock
                        ? 'Out of Stock'
                        : Array.isArray(item.availableSizes) && item.availableSizes.length > 0
                          ? 'Select Size'
                          : 'Add to Cart'}
                    </button>
                    <button
                      className="remove-btn"
                      onClick={() => handleRemoveFromWishlist(item._id)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
                </div>
              );
            })}
          </div>

          <div className="wishlist-summary">
            <h2>Wishlist Summary</h2>
            <div className="summary-item">
              <span>Total Items:</span>
              <span>{getWishlistCount()}</span>
            </div>
            <button className="continue-shopping" onClick={handleContinueShopping}>
              Continue Shopping
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WishlistPage;
